import { render, staticRenderFns } from "./Inquiries2column.vue?vue&type=template&id=1701834e&scoped=true&"
import script from "./Inquiries2column.vue?vue&type=script&lang=js&"
export * from "./Inquiries2column.vue?vue&type=script&lang=js&"
import style0 from "./Inquiries2column.vue?vue&type=style&index=0&id=1701834e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1701834e",
  null
  
)

export default component.exports